import { getData } from './http';

let key;

const FINDURL = 'https://api.addressy.com/Capture/Interactive/Find/v1.10/json3.ws';
const RETRIEVEURL = 'https://api.addressy.com/Capture/Interactive/Retrieve/v1.20/json3.ws';

function request(url, obj) {
    const params = new URLSearchParams();
    for (const key in obj) {
        params.set(key, obj[key]);
    }
    return getData(`${url}?${params}`);
}

export function find(term, countryCode, id) {
    return request(FINDURL, {
        Key: key,
        Countries: countryCode,
        Text: term,
        Container: id
    });
}

export function retrieve(id) {
    return request(RETRIEVEURL, {
        Key: key,
        Id: id
    });
}

export function setKey(newKey) {
    key = newKey;
}
